import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { inject } from "@angular/core";
import { UserInfoService } from "../../services/user-info.service";
import { PlatformMismatchNoticeService } from "../../services/platform-mismatch-notice.service";
import { canAccessPlatform } from "./platform-role-policy";

/**
 * Guard for Wellvia (paid) platform routes. Only PAID_CUSTOMER role may access.
 * ACTIVE and EXTERNAL users are redirected to the ePAK hub (/).
 * Platform switching must go through platform tabs (backend role switch).
 */
export const paidCustomerGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): boolean => {
  const router = inject(Router);
  const userInfoService = inject(UserInfoService);
  const platformMismatchNotice = inject(PlatformMismatchNoticeService);
  const role = userInfoService.getSessionContext()?.patientRole;

  if (role == null) {
    return true; // AuthGuard handles unauthenticated; let it run first
  }

  if (canAccessPlatform(role, "paid")) {
    return true;
  }

  platformMismatchNotice.notifyPaidRouteBlocked();
  router.navigate(["/"]);
  return false;
};
